import { render, staticRenderFns } from "./EmployeeTrackAndTraceInFeedback.vue?vue&type=template&id=13a68e58&scoped=true"
import script from "./EmployeeTrackAndTraceInFeedback.vue?vue&type=script&lang=js"
export * from "./EmployeeTrackAndTraceInFeedback.vue?vue&type=script&lang=js"
import style0 from "./EmployeeTrackAndTraceInFeedback.vue?vue&type=style&index=0&id=13a68e58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a68e58",
  null
  
)

export default component.exports